import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetExportLifeContract } from "../../../api/contract/service"
import { callExportLifeContract } from "../../../api/export"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import insuranceStatus from "../../../data/statusLife"
import { FormatCurrencys } from "../../../utils/commonUtil"
import SmartTable from "../../../components/common/table-component";


const Index = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', startDate: null, endDate: null, status: 1, agentCode: '', contractNumber: '' });
	const [lifeContractList, setLifeContractList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);

	useEffect(() => {
		loadData();

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = {
			page: request.page,
			maxResult: request.maxResult,
			keyword: request.keyword,
			startDate: fromDate,
			endDate: toDate,
			agentCode: request.agentCode,
			contractNumber: request.contractNumber,
			status: Number(request.status)
		};
		const rsp = await dispatch(callGetExportLifeContract(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setLifeContractList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChangeContract = (e) => {
		setRequest((prev) => ({ ...prev, contractNumber: e.target.value }));
	};

	const handleChangeAgentCode = (e) => {
		setRequest((prev) => ({ ...prev, agentCode: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const selectstartDate = (e) => {
		setRequest((prev) => ({
			...prev,
			startDate: e.target.value,
		}));
	}

	const selectendDate = (e) => {
		setRequest((prev) => ({
			...prev,
			endDate: e.target.value,
		}));
	}

	const selectStatus = (e) => {
		setRequest((prev) => ({
			...prev,
			status: e.target.value,
		}));
	}

	const downloadExcel = async () => {
		try {
			let data = {
				page: request.page,
				maxResult: totalRecord,
				keyword: request.keyword,
				startDate: fromDate,
				endDate: toDate,
				agentCode: request.agentCode,
				contractNumber: request.contractNumber,
				status: Number(request.status)
			};
			let response = await callExportLifeContract(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text333", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.report.lifeInsurance")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={fromDate}
														onChange={date => setFromDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={toDate}
														onChange={date => setToDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('search.contractNumber')}</label>
													<input
														type="text"
														name="contractNumber"
														className="form-control-uld"
														placeholder={t('search.contractNumber') + "..."}
														onChange={handleChangeContract}
														value={request.contractNumber}
														autoComplete="off"
													/>
												</div>

												<div className="col-md-2">
													<div className="form-group">
														<label>{t('report.lifeInsurance.agentCode')}</label>
														<input
															type="text"
															name="agentCode"
															className="form-control-uld"
															placeholder={t('report.lifeInsurance.agentCode') + "..."}
															onChange={handleChangeAgentCode}
															value={request.agentCode}
															autoComplete="off"
															required />
													</div>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={selectStatus}
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															insuranceStatus.map((item) => (
																<option key={item.id} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>

												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "report.lifeInsurance.agentCode", key: "agentCode" },
							{ labelKey: "report.lifeInsurance.agentName", key: "agentFirstName", style: { minWidth: '150px' } },
							{ labelKey: "report.lifeInsurance.agentSurname", key: "agentLastName", style: { minWidth: '150px' } },
							{ labelKey: "report.lifeInsurance.contractNo", key: "contractNumber" },
							{ labelKey: "report.lifeInsurance.customerName", key: "fullName", style: { minWidth: '150px' } },
							{ labelKey: "report.lifeInsurance.signedDate", key: "signedDate", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "report.lifeInsurance.age", key: "age" },
							{ labelKey: "report.lifeInsurance.packageOption", key: "packageMoneyName" },
							{ labelKey: "report.lifeInsurance.price", key: "payPerMonth", render: (val) => FormatCurrencys(val) },
							{ labelKey: "report.lifeInsurance.lastPay", key: "lastPay" },
							{ labelKey: "report.lifeInsurance.monthsArrears", key: "monthsArrears" },
							{ labelKey: "report.lifeInsurance.amountArrears", key: "amountArrears", render: (val) => FormatCurrencys(val) },
							{ labelKey: "report.lifeInsurance.status", key: "status", style: { minWidth: '150px' }, render: (val) => <span className={`badge ${String(val) === "1" ? "bg-success" : "bg-danger"}`}>{t('statusLife.' + val)}</span> },
							{ labelKey: "report.lifeInsurance.createDate", key: "createdAt", style: { minWidth: '150px' }, render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
							{ labelKey: "report.lifeInsurance.createBy", key: "createdBy", style: { minWidth: '150px' } },
							{ labelKey: "report.lifeInsurance.modifiedDate", key: "updatedAt", render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
							{ labelKey: "report.lifeInsurance.modifiedBy", key: "updatedBy" },
						]}
	data={{ result: lifeContractList }}
	rowKey="contractNumber"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={true}
	rowNumberOffset={(request.page - 1) * request.maxResult}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
